import { useQuery } from '@tanstack/react-query';

interface FeatureRow {
  featureUniqueLabel: string;
  visibleAdmin: number;
  position: number;
}

export interface FeatureInfo {
  position: number;
}

async function fetchFeatures(): Promise<Map<string, FeatureInfo>> {
  const res = await fetch('/api/features');
  const data = await res.json();
  const features: FeatureRow[] = data.features ?? [];
  // `/api/features` already filters to `visibleAdmin: 1` server-side and
  // orders by `position` — a key present here is both "enabled" and carries
  // its admin-grid drag-and-drop order, which `LeftSidebar.tsx` sorts by.
  return new Map(features.map(f => [f.featureUniqueLabel, { position: f.position }]));
}

// Admin > Features toggles (`Feature.visibleAdmin`) + drag-and-drop order
// (`Feature.position`) — used to gate and order every `SIDEBAR_TOOL_FEATURE_KEYS`
// sidebar tool. Returns `null` while still loading — callers should treat
// that as "don't restrict/reorder yet" so tools don't flash hidden then
// visible, or jump around, on first load.
export function useFeatureFlags(): Map<string, FeatureInfo> | null {
  const { data } = useQuery({
    queryKey: ['public-features'],
    queryFn: fetchFeatures,
    staleTime: 300_000,
  });
  return data ?? null;
}
